export enum WIDGET_PLAY {
    /**
     * @value Display information
     * @description Text used for example in the widget-play widget as a label for a toggle button from which the user can toggle settings related to the video information.
     */
    DISPLAY_INFORMATION = 'PLAY.DISPLAY_INFORMATION',
    /**
     * @value Display metadata
     * @description Text used for example in the widget-play as the title of a section where the user can toggle the settings related to the video metadata.
     */
    DISPLAY_METADATA = 'PLAY.DISPLAY_METADATA',
    /**
     * @value Display video
     * @description Text used to label an action allowing the user to display a video
     */
    DISPLAY_VIDEO = 'PLAY.DISPLAY_VIDEO',
    /**
     * @value Error loading data, please try again.
     */
    ERROR_WHILE_FETCHING_DATA = 'SA_ANALYTICS_FETCH_DATA_RETRY_DESC',
    /**
     * @value Horizontal
     * @description Determine the orientation of the player in the widget
     */
    HORIZONTAL = 'PLAY.HORIZONTAL',
    /**
     * @value Most viewed
     * @description Used, for example, in a dropdown to sort videos by their number of views
     */
    MOST_VIEWED = 'PLAY.MOST_VIEWED',
    /**
     * @value Over the player
     */
    OVER_THE_PLAYER = 'PLAY.OVER_THE_PLAYER',
    /**
     * @value Pick video
     * @description Label of the confirmation button allowing the user to confirm his choice of video
     */
    PICKER_DIALOG_CONFIRM = 'WIDGET_PLAY.SETTINGS_PICKER_DIALOG_CONFIRM', // Pick video
    /**
     * @value Search videos
     * @description Generic search videos label (used in text field as placeholder, could be use as a button label etc…)
     */
    PICKER_DIALOG_SEARCH_PLACEHOLDER = 'PLAY.SEARCH_VIDEOS',
    /**
     * @value Pick a video
     * @description Title of the dialog box displaying the list of videos and asking the user to pick a video
     */
    PICKER_DIALOG_TITLE = 'WIDGET_PLAY.SETTINGS_PICKER_DIALOG_TITLE', // Pick a video
    /**
     * @value Pick from gallery
     * @description Text used for example to label a button inviting the user to choose a video in the video gallery.
     */
    PICK_VIDEO_FROM_GALLERY = 'PLAY.PICK_VIDEO_FROM_GALLERY',
    /**
     * @value Published a video in %INSTANCE_NAME% > %VIDEO_GALLERY%
     * @description Text used to indicate to the user that a video has been published in the video gallery of a particular instance (site).
     */
    PUBLISHED_VIDEO_IN_GALLERY = 'PLAY.PUBLISHED_VIDEO_IN_INSTANCE_VIDEO_GALLERY',
    /**
     * @value Only published videos can be added to a video widget
     */
    PUBLISHED_VIDEO_ONLY_WARNING = 'PLAY.PUBLISHED_VIDEO_ONLY_WARNING',
    /**
     * @value Replace video
     * @description Upload new video file to update video
     */
    REPLACE_VIDEO = 'PLAY.VIDEO_UPLOAD_NEW_VERSION_CTA',
    /**
     * @value Select video
     * @description Text used for example to label a checkbox allowing the user to select a video
     */
    SELECT_VIDEO = 'PLAY.SELECT_VIDEO',
    /**
     * @value Pick a video
     * @description Label select
     */
    SETTING = 'WIDGET_PLAY.SETTINGS_SETTING', // Pick a video
    /**
     * @value Starred
     */
    STARRED = 'FRONT.WIDGET_FILE_LIST.SETTINGS.FOLDER.DRIVE.STARRED',
    /**
     * @value Source
     * @description Subtitle of the setting asking the user to choose a video source file
     */
    SUBTITLE = 'WIDGET_PLAY.SETTINGS_SUBTITLE', // Source
    /**
     * @value Users will not be able to access video detail page
     * @description Text used as a message to warn the user that they will not be able to access the video detail page when certain conditions are met.
     */
    UNAVAILABLE_LINK = 'PLAY.USERS_UNABLE_ACCESS_VIDEO_DETAIL_PAGE_WARNING',
    /**
     * @value Under the player
     */
    UNDER_THE_PLAYER = 'PLAY.UNDER_THE_PLAYER',
    /**
     * @value Pick a video
     * @description Uploader button label asking the user to pick a video from the library
     */
    UPLOADER_LABEL = 'WIDGET_PLAY.SETTINGS_UPLOADER_LABEL', // Pick a video
    /**
     * @value Upload from computer
     * @description Label used on video upload button from a desktop computer device
     */
    UPLOAD_VIDEO_FROM_COMPUTER = 'PLAY.UPLOAD_VIDEO_FROM_COMPUTER',
    /**
     * @value Upload from Google Drive
     * @description List item from widget upload video dropdown
     */
    UPLOAD_VIDEO_FROM_DRIVE = 'PLAY.UPLOAD_VIDEO_FROM_DRIVE',
    /**
     * @value Vertical
     * @description Determine the orientation of the player in the widget
     */
    VERTICAL = 'PLAY.VERTICAL',
}
